(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-pro-staff"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pa-pro-staff')) {
  customElements.define('pa-pro-staff', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.dialog = this.querySelector('dialog');
      this.querySelectorAll('[data-open-agreement]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => {
          this.opener = button;
          this.dialog.showModal();
          this.dialog.querySelector('.agreement-body').scrollTop = 0;
        });
      });
      this.querySelectorAll('[data-close-agreement]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
      this.dialog.addEventListener('close', () => this.opener?.focus());
      this.form = this.querySelector('[data-application-form]');
      if (!this.form) return;
      this.steps = [...this.form.querySelectorAll('.form-step')];
      this.files = {video: [], photo: []};
      this.connected = this.dataset.connected === 'true';
      this.submitButton = this.form.querySelector('[data-submit]');
      this.submitButton.addEventListener('click', () => this.submitApplication());
      this.current = 0;
      this.next = this.form.querySelector('[data-next]');
      this.back = this.form.querySelector('[data-back]');
      this.review = this.form.querySelector('[data-review]');
      this.form.querySelector('.form-actions').hidden = false;
      this.querySelector('[data-step-count]').hidden = false;
      this.form.addEventListener('submit', event => event.preventDefault());
      this.form.addEventListener('keydown', event => {
        if (event.key === 'Enter' && event.target.matches('input:not([type=file]):not([type=checkbox]):not([type=radio])')) {
          event.preventDefault();
          this.advance();
        }
      });
      this.next.addEventListener('click', () => this.advance());
      this.back.addEventListener('click', () => this.showStep(Math.max(0, this.current - 1), true));
      this.form.elements.agreement.addEventListener('change', () => {
        this.querySelector('[data-agreement-error]').hidden = this.form.elements.agreement.checked;
        this.form.elements.agreement.removeAttribute('aria-invalid');
      });
      this.form.querySelectorAll('[data-upload-area]').forEach(area => {
        const input = area.querySelector('input[type=file]');
        const zone = area.querySelector('[data-drop-zone]');
        input.addEventListener('change', () => {
          this.addFiles([...input.files], area);
          input.value = '';
        });
        ['dragenter', 'dragover'].forEach(type => zone.addEventListener(type, event => {
          event.preventDefault();
          zone.classList.add('dragging');
        }));
        zone.addEventListener('dragleave', () => zone.classList.remove('dragging'));
        zone.addEventListener('drop', event => {
          event.preventDefault();
          zone.classList.remove('dragging');
          this.addFiles([...event.dataTransfer.files], area);
        });
      });
      this.showStep(0);
    }
    validStep(index) {
      const invalid = [...this.steps[index].querySelectorAll('input,textarea')].find(input => !input.checkValidity());
      if (!invalid) return true;
      if (invalid.name === 'agreement') {
        this.querySelector('[data-agreement-error]').hidden = false;
        invalid.setAttribute('aria-invalid', 'true');
      }
      invalid.reportValidity();
      invalid.focus();
      return false;
    }
    advance() {
      if (this.current >= this.steps.length || !this.validStep(this.current)) return;
      if (this.current === this.steps.length - 1) {
        for (let index = 0; index < this.steps.length; index++) {
          const invalid = [...this.steps[index].querySelectorAll('input,textarea')].some(input => !input.checkValidity());
          if (invalid) {
            this.showStep(index, true);
            this.validStep(index);
            return;
          }
        }
        this.renderReview();
      }
      this.showStep(this.current + 1, true);
    }
    showStep(index, focus = false) {
      this.current = index;
      this.steps.forEach((step, stepIndex) => step.hidden = stepIndex !== index);
      const reviewing = index === this.steps.length;
      this.review.hidden = !reviewing;
      this.form.querySelector('[data-intake-submit]').hidden = !reviewing || !this.connected;
      if (reviewing && this.connected) this.loadTurnstile();
      this.back.hidden = index === 0;
      this.next.hidden = reviewing;
      this.form.querySelector('[data-required-note]').hidden = reviewing;
      this.next.textContent = index === this.steps.length - 1 ? this.messages.review : this.messages.continue + ' →';
      this.querySelector('[data-step-count]').textContent = reviewing ? this.messages.review : this.messages.step.replace('[number]', String(index + 1).padStart(2, '0'));
      this.querySelector('[data-progress]').style.width = Math.min(100, (index + 1) / this.steps.length * 100) + '%';
      this.querySelectorAll('[data-step-marker]').forEach((marker, markerIndex) => {
        if (markerIndex === Math.min(index, this.steps.length - 1)) marker.setAttribute('aria-current', 'step');
        else marker.removeAttribute('aria-current');
      });
      if (focus) (reviewing ? this.review.querySelector('h3') : this.steps[index].querySelector('legend')).focus();
    }
    addFiles(incoming, area) {
      const category = area.dataset.uploadArea;
      const unique = [...this.files[category]];
      incoming.forEach(file => {
        if (!unique.some(existing => existing.name === file.name && existing.size === file.size && existing.lastModified === file.lastModified)) unique.push(file);
      });
      const photo = category === 'photo';
      const images = ['image/jpeg','image/png','image/gif','image/webp','image/heic','image/heif','image/avif','image/tiff','image/bmp'];
      const videos = ['video/mp4','video/quicktime','video/webm','video/x-m4v','video/x-msvideo','video/x-matroska','video/mpeg'];
      const validType = file => images.includes(this.fileType(file)) || (!photo && videos.includes(this.fileType(file)));
      const error = area.querySelector('[data-file-error]');
      if (unique.length > (photo ? 1 : 5) || unique.some(file => file.size <= 0 || file.name.length > 200 || file.size > (photo ? 10 * 1024 ** 2 : 10 * 1024 ** 3) || !validType(file))) {
        error.textContent = photo ? this.messages.photo_error : this.messages.file_error;
        error.hidden = false;
        return;
      }
      error.hidden = true;
      this.files[category] = unique;
      this.renderFiles(area);
    }
    renderFiles(area) {
      const category = area.dataset.uploadArea;
      const list = area.querySelector('[data-file-list]');
      list.replaceChildren();
      this.files[category].forEach((file, index) => {
        const item = document.createElement('li');
        const label = document.createElement('span');
        label.textContent = file.name;
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = '×';
        button.setAttribute('aria-label', this.messages.remove.replace('[name]', file.name));
        button.addEventListener('click', () => {
          this.files[category].splice(index, 1);
          this.renderFiles(area);
          area.querySelector('input[type=file]').focus();
        });
        item.append(label, button);
        list.append(item);
      });
    }
    renderReview() {
      const data = new FormData(this.form);
      const list = this.form.querySelector('[data-review-list]');
      list.replaceChildren();
      Object.entries(this.messages.labels).forEach(([key, label]) => {
        const term = document.createElement('dt');
        const value = document.createElement('dd');
        term.textContent = label;
        value.textContent = ['uploads','photo'].includes(key) ? (this.files[key === 'uploads' ? 'video' : 'photo'].map(file => file.name).join('\n') || this.messages.none) : key === 'agreement' ? this.messages.yes : (data.get(key) || this.messages.none);
        list.append(term, value);
      });
    }
    async loadTurnstile() {
      if (this.turnstileWidget !== undefined || !this.dataset.sitekey || this.loadingTurnstile) return;
      this.loadingTurnstile = true;
      try {
        if (!window.turnstile) {
          if (!window.paTurnstileLoader) window.paTurnstileLoader = new Promise((resolve,reject) => {
            const script = document.createElement('script');
            script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
            script.async = true;
            script.onload = resolve;
            script.onerror = reject;
            document.head.append(script);
          });
          await window.paTurnstileLoader;
        }
        this.turnstileWidget = window.turnstile.render(this.querySelector('[data-turnstile]'), {
          sitekey:this.dataset.sitekey,action:'pro_staff',theme:'light',size:'flexible',
          callback:token => this.turnstileToken = token,
          'expired-callback':() => this.turnstileToken = null,
          'error-callback':() => this.turnstileToken = null
        });
      } catch {this.showSubmitError(this.messages.security_check);}
      finally {this.loadingTurnstile = false;}
    }
    showSubmitError(message) {
      const error=this.querySelector('[data-submit-error]');
      error.textContent=message;error.hidden=false;
    }
    fileType(file) {
      if(file.type) return file.type;
      const ext=file.name.split('.').pop().toLowerCase();
      return {jpg:'image/jpeg',jpeg:'image/jpeg',png:'image/png',gif:'image/gif',webp:'image/webp',heic:'image/heic',heif:'image/heif',avif:'image/avif',tif:'image/tiff',tiff:'image/tiff',bmp:'image/bmp',mp4:'video/mp4',mov:'video/quicktime',webm:'video/webm',m4v:'video/x-m4v',avi:'video/x-msvideo',mkv:'video/x-matroska',mpeg:'video/mpeg',mpg:'video/mpeg'}[ext] || '';
    }
    async api(path,options={}) {
      const endpoint=new URL(this.dataset.endpoint);
      if(endpoint.protocol!=='https:') throw new Error(this.messages.not_configured);
      const headers=new Headers(options.headers);
      if(this.uploadSession) headers.set('Authorization','Bearer '+this.uploadSession.token);
      const response=await fetch(endpoint.origin+path,{...options,headers,signal:AbortSignal.timeout(180000),credentials:'omit'});
      let result;
      try {result=await response.json();} catch {throw new Error(this.messages.upload_interrupted);}
      if(!response.ok) {const error=new Error(result.error || this.messages.upload_interrupted);error.status=response.status;throw error;}
      return result;
    }
    async submitApplication() {
      if(!this.connected || this.sending || this.sent) return;
      if(!this.dataset.endpoint || !this.dataset.sitekey) return this.showSubmitError(this.messages.not_configured);
      if(!this.uploadSession && !this.turnstileToken) return this.showSubmitError(this.messages.security_check);
      if(!this.uploadSession) {
        for(let index=0; index<this.steps.length; index++) {
          if([...this.steps[index].querySelectorAll('input,textarea')].some(input=>!input.checkValidity())) {
            this.showStep(index,true);this.validStep(index);return;
          }
        }
      }
      this.sending=true;
      this.querySelector('[data-submit-error]').hidden=true;
      const status=this.querySelector('[data-upload-status]');
      const progress=this.querySelector('[data-upload-progress]');
      status.hidden=false;
      const answers=Object.fromEntries(new FormData(this.form));
      this.form.querySelectorAll('button,input,textarea').forEach(control=>control.disabled=true);
      try {
        if(!this.submissionPayload) {
          this.selectedFiles=Object.entries(this.files).flatMap(([category,files])=>files.map(file=>({category,file})));
          this.submissionPayload={...answers,request_id:crypto.randomUUID(),agreement:true,agreement_version:'painted-arrow-pro-staff-2026-09-24',files:this.selectedFiles.map(({category,file})=>({name:file.name,size:file.size,type:this.fileType(file),category}))};
        }
        if(!this.uploadSession) {
          status.textContent=this.messages.submitting;
          this.uploadSession=await this.api('/applications',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({...this.submissionPayload,turnstile_token:this.turnstileToken})});
        }
        if(!this.uploadSession.complete) {
          const total=this.selectedFiles.reduce((sum,{file})=>sum+file.size,0);
          let completed=0;
          progress.hidden=!total;
          for(let index=0;index<this.selectedFiles.length;index++) {
            const {file}=this.selectedFiles[index];
            let state=await this.api('/uploads/'+index);
            while(!state.complete) {
              const offset=state.offset;
              if(!Number.isSafeInteger(offset) || offset<0 || offset>=file.size) throw new Error(this.messages.upload_interrupted);
              const end=Math.min(offset+this.uploadSession.chunk_size,file.size);
              const percent=Math.floor((completed+offset)/total*100);
              progress.value=percent;
              status.textContent=this.messages.uploading.replace('[name]',file.name).replace('[percent]',String(percent));
              try {
                state=await this.api('/uploads/'+index,{method:'PUT',headers:{'Content-Type':'application/octet-stream','Content-Range':`bytes ${offset}-${end-1}/${file.size}`},body:file.slice(offset,end)});
              } catch(error) {
                state=await this.api('/uploads/'+index);
                if(state.offset<=offset && !state.complete) throw error;
              }
              if(state.offset<=offset && !state.complete) throw new Error(this.messages.upload_interrupted);
            }
            completed+=file.size;
            progress.value=Math.floor(completed/total*100);
          }
          status.textContent=this.messages.finishing;
          await this.api('/complete',{method:'POST'});
        }
        this.sent=true;
        this.review.hidden=true;
        this.form.querySelector('.form-actions').hidden=true;
        this.querySelector('[data-turnstile]').hidden=true;
        this.submitButton.hidden=true;
        progress.hidden=true;
        status.textContent=this.messages.submitted;
        status.setAttribute('tabindex','-1');status.focus();
        this.files={video:[],photo:[]};this.selectedFiles=[];this.submissionPayload=null;this.uploadSession=null;
      } catch(error) {
        this.showSubmitError(error.message || this.messages.upload_interrupted);
        if(!this.uploadSession && error.status===400) {
          this.submissionPayload=null;
          this.form.querySelectorAll('button,input,textarea').forEach(control=>control.disabled=false);
        }
        this.submitButton.disabled=false;
        this.submitButton.textContent=this.messages.retry;
        if(!this.uploadSession && window.turnstile && this.turnstileWidget!==undefined) {this.turnstileToken=null;window.turnstile.reset(this.turnstileWidget);}
      } finally {this.sending=false;}
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
